import type { App } from 'vue'
import * as array from '@/utils/array'
import * as contentPreview from '@/utils/contentPreview'
import * as object from '@/utils/object'
import * as string from '@/utils/string'
import * as time from '@/utils/time'
import * as url from '@/utils/url'
import * as localStorage from '@/utils/localStorage'
import * as device from '@/utils/device'
import * as youtube from '@/utils/youtube'

export const utils = {
  array,
  contentPreview,
  object,
  string,
  time,
  url,
  localStorage,
  device,
  youtube
}

export default {
  install(app: App) {
    app.config.globalProperties.$utils = utils
  }
}
